
import {connect} from 'react-redux';
import axios from 'axios';
import {Platform} from "react-native";

import store from "../../../../redux/store";
import {typeExport} from "../../../../redux/store/type";
import DetailsOperatorFireApplyScreen from "../DetailsOperatorFireApplyScreen";

const mapStateToProps = (state) => ({
    results: state.reducerDetailsOperatorFireApplyScreen.results,
    isLoading: state.reducerDetailsOperatorFireApplyScreen.isLoading,
    NoInternetDialog: state.reducerDetailsOperatorFireApplyScreen.NoInternetDialog,

    resultsSet: state.reducerDetailsOperatorFireApplyScreen.resultsSet,
    isLoadingSet: state.reducerDetailsOperatorFireApplyScreen.isLoadingSet,
    NoInternetDialogSet: state.reducerDetailsOperatorFireApplyScreen.NoInternetDialogSet,

    position: state.reducerDetailsOperatorFireApplyScreen.position,
    id_category: state.reducerDetailsOperatorFireApplyScreen.id_category,


    positionPersonnel: state.reducerDetailsOperatorFireApplyScreen.positionPersonnel,
    id_Personnel: state.reducerDetailsOperatorFireApplyScreen.id_Personnel,

    CartList: state.reducerSplashGetAllData.CartList,
    PriceAll: state.reducerSplashGetAllData.PriceAll,

    token: state.reducerSplashGetAllData.token,
    user: state.reducerSplashGetAllData.user,
    wallet: state.reducerSplashGetAllData.wallet,
    DataSplashScreen: state.reducerSplashGetAllData,
    ListOperatorFireApplyScreen: state.reducerListOperatorFireApplyScreen,
 //   ListMessageHistoryOperatorFireScreen: state.reducerListMessageHistoryOperatorFireScreen,
    // token: state.reducerSplash.token,

    FoodItem: state.reducerSplashGetAllData.FoodItem,
});

const mapDispatchToProps = (dispatch) => ({
    callService: (url, params, type, typeConnection, token) => dispatch(callWebservice(url, params, type, typeConnection, token)),

    callserviceActionRefresh: () => dispatch(serviceActionRefresh()),

});

const getDataDisatch = (dispatch, url, params, type, typeConnection, token) => {

    switch (type) {
        case typeExport.TypeGetDetailsOperatorFireApplyScreen:
            dispatch(serviceActionPending());

            break;

        case typeExport.TypeSetDetailsOperatorFireApplyScreen:
            dispatch(serviceActionPendingSet());

            break;

        default:
    }


    //Tools.consoleCustumize("url",baseUrl + url + params);
    let formData = new FormData();
    formData.append('_operation', typeExport._Fire);
    // // formData.append('lang', params.lang);
    formData.append('mode', "GetDetails");
    formData.append('RequestID', params.RequestID);
    formData.append('teamID', params.teamID);
    //   formData.append('state_params', params.state_params);
    //formData.append('_session', params._session == null ? '' : params._session);
    formData.append('token', store.getState().reducerSplashGetAllData.token == null ? '' : store.getState().reducerSplashGetAllData.token);
    formData.append('device', global._Device ? global._Device.value : null);
    formData.append('token_fb', store.getState().reducerSplashGetAllData.token_fb);

    const config = {
        headers: {
            "Content-Type": "multipart/form-data; charset=utf-8;",
            timeout: typeExport._TIMEOUT,
            // 'Content-Type': 'application/json',
            //  "Authorization": `Basic ${base64.encode(params.username + ':' + params.password)}`
        }
    };


    /*  axios(
          {
              // url: baseUrl + url + params,
              //url: url + "&after=0000-00-00",
              // url: url+`&${params.page}&${params.after}` ,
              url: url + params,
              // params:params,
              method: typeConnection,
              headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
              },
              /!*      headers: {'X-Requested-With': 'XMLHttpRequest'},*!/
          }
      )*/
    axios.post(url, formData, config)

    // axios(
    //     {
    //         // url: baseUrl + url + params,
    //         // url: url+"&after=0000-00-00" ,
    //         url: baseUrlWP + url,
    //         method: typeConnection,
    //         params: params,
    //         headers: {
    //             'Content-Type': 'application/x-www-form-urlencoded'
    //         },
    //         timeout: typeExport._TIMEOUT,
    //         /*      headers: {'X-Requested-With': 'XMLHttpRequest'},*/
    //     }
    // )
        .then(response => {
            let data = response.data;
            switch (type) {
                case typeExport.TypeGetDetailsOperatorFireApplyScreen:
                    if (data.success === true) {
                        dispatch(serviceActionSuccess(data.result));
                    }
                    else {
                        switch (type) {
                            case typeExport.TypeGetDetailsOperatorFireApplyScreen:
                                dispatch(serviceActionError(response.data))

                                break;

                            case typeExport.TypeSetDetailsOperatorFireApplyScreen:
                                dispatch(serviceActionErrorSet(response.data))

                                break;

                            default:
                        }
                    }
                    break;

                case typeExport.TypeSetDetailsOperatorFireApplyScreen:

                    break;

                default:
            }
        }).catch((e) => {

        switch (type) {
            case typeExport.TypeGetDetailsOperatorFireApplyScreen:
                dispatch(serviceActionError(e))

                break;

            case typeExport.TypeSetDetailsOperatorFireApplyScreen:
                dispatch(serviceActionErrorSet(e))

                break;

            default:
        }
    })
}


// export const callSetStateCity =  (state_name,state_id,city_name,city_id)  => {

//     return dispatch (serviceActionSuccessSetCityStateData (state_name,state_id,city_name,city_id) )
// }
export const callWebservice = (url, params, type, typeConnection, token) => {
    return dispatch => {

        // if (Platform.OS === 'ios') {
        //     NetInfo.isConnected.addEventListener('connectionChange', (isConnected) => {
        //             if (isConnected) {
        //                 getDataDisatch(dispatch, url, params, type, typeConnection, token);
        //             }
        //             else {
        //                 dispatch(serviceActionError("No Internet Connection"));
        //             }
        //         }
        //     );
        // }
        // else {
        // NetInfo.isConnected.fetch().then((isConnected) => {
        //     if (isConnected) {
        //         getDataDisatch(dispatch, url, params, type, typeConnection, token);
        //     }
        //     else {
        //         switch (type) {
        //
        //             case typeExport.TypeGetDetailsOperatorFireApplyScreen:
        //                 dispatch(serviceActionError("no connect"));
        //                 break;
        //             default:
        //         }
        //     }
        // });

            if (store.getState().reducerSplashGetAllData.Connection) {
                getDataDisatch(dispatch, url, params, type, typeConnection, token);
            }
            else {
                switch (type) {
                    case typeExport.TypeGetDetailsOperatorFireApplyScreen:
                        dispatch(serviceActionError('error_Connection'))

                        break;

                    case typeExport.TypeSetDetailsOperatorFireApplyScreen:
                        dispatch(serviceActionErrorSet('error_Connection'))

                        break;

                    default:
                }
            }

        //}

        /* NetInfo.getConnectionInfo().done(
             (isConnected) => {
                 if (isConnected) {
                     getDataDisatch(dispatch, url, params, type, typeConnection, token);
                 }
                 else {
                     switch (type) {

                         case typeExport.TypeGetDetailsOperatorFireApplyScreen:
                             dispatch(serviceActionError("no connect"));
                             break;
                         default:
                     }
                 }
             }
         )*/
    }
}


export const serviceActionPending = () => ({
    type: typeExport.DetailsOperatorFireApplyScreen_SERVICE_PENDING,
    NoInternetDialog: false,
    isLoading: true,
    showDialohCity: false

})

export const serviceActionError = (error) => ({
    type: typeExport.DetailsOperatorFireApplyScreen_SERVICE_ERROR,
    NoInternetDialog: true,
    error: error,
    isLoading: false,
    showDialohCity: false

})

export const serviceActionSuccess = (data) => ({
    type: typeExport.DetailsOperatorFireApplyScreen_SERVICE_SUCCESS,
    NoInternetDialog: false,
    results: data,
    isLoading: false,
})

export const serviceActionPendingSet = () => ({
    type: typeExport.DetailsOperatorFireApplyScreen_SERVICE_PENDING_Set,
    NoInternetDialogSet: false,
    isLoadingSet: true,

})

export const serviceActionErrorSet = (error) => ({
    type: typeExport.DetailsOperatorFireApplyScreen_SERVICE_ERROR_Set,
    NoInternetDialogSet: true,
    error: error,
    isLoadingSet: false,

})

export const serviceActionSuccessSet = (data) => ({
    type: typeExport.DetailsOperatorFireApplyScreen_SERVICE_SUCCESS_Set,
    NoInternetDialogSet: false,
    resultsSet: data,
    isLoadingSet: false,
})
export const serviceActionRefresh = () => ({
    type: typeExport.DetailsOperatorFireApplyScreen_SERVICE_REFRESH,
    NoInternetDialog: false,
    results: null,
    isLoading: false,
})


export default connect(mapStateToProps, mapDispatchToProps)(DetailsOperatorFireApplyScreen);
